import type { Language } from './language';

/**
 * Supported UI languages and their corresponding locale codes.
 *
 * @example
 * const codes = languages.map(l => l.code); // ['en', 'ar']
 */
const languages: Language[] = [
  {
    code: 'en',
    name: 'English',
    displayName: 'English',
    direction: 'ltr',
    isAutoTranslated: false,
    locale: 'en-US',
  },
  // {
  //   code: 'fr',
  //   name: 'French',
  //   displayName: 'Français',
  //   direction: 'ltr',
  //   isAutoTranslated: false,
  //   locale: 'fr-FR',
  // },
  // {
  //   code: 'es',
  //   name: 'Spanish',
  //   displayName: 'Español',
  //   direction: 'ltr',
  //   isAutoTranslated: false,
  //   locale: 'es-ES',
  // },
  {
    code: 'ar',
    name: 'Arabic',
    displayName: 'اَلْعَرَبِيَّةُ',
    direction: 'rtl',
    isAutoTranslated: false,
    locale: 'ar-EG',
  },
  // ... more languages are pre-configured but commented out
];

/**
 * Default language used by the application.
 */
const defaultLanguage: Language =
  languages.find((language) => language.code === 'en') ?? languages[0];

/**
 * Global i18n configuration object aggregating available languages and the default one.
 *
 * @returns Returns an object with two properties: `languages` and `defaultLanguage`.
 * @example
 * import { I18N_CONFIG } from '@indutrust/shared-model';
 * console.log(I18N_CONFIG.defaultLanguage.code); // 'en'
 */
export const I18N_CONFIG: {
  languages: Language[];
  defaultLanguage: Language;
} = {
  languages,
  defaultLanguage,
};
